import moment from 'moment';
import { pickBy, isNil, filter, get, includes, keys, forEach, cloneDeep, indexOf, size, head, isEmpty, startsWith } from 'lodash';

// local dependencies
import { DATA_TYPES, SORT_DIRECTIONS, DATE_TIME_INFO_FORMAT } from 'constants/common';
import { SELECT_ALL_OPTION_VALUE } from 'constants/common';

/**
 * @type {function}
 * @desc Sort and filter table offline.
 * @param {object} payload
 * @example
 * import { sortFilterOffline } from 'resolvers/tableSortFilter';
 */
export const sortFilterOffline = ( { /*items = [],*/ filters = {}, columns = [], originalItems = [], searchFilter=[], searchableColumns= [] } = {} ) => {
    log.debug( 'resolver.selectedSortFilters()' );

    // get selected sort and filters
    const selectedSortFilters = pickBy( filters, _filter => ! isNil( _filter ) );

    // find columns with selected sort and filters
    const selectedColumns = filter( get( columns, 'primary', [] ), ( column ) => {
        return includes( keys( selectedSortFilters ), column.name );
    } );

    // filtered items
    let filteredItems = cloneDeep( originalItems );

    // get the list of applicable filyters
    let filterSection = [];

    // for each selected column, filter items
    forEach( selectedColumns, _column => {

        // filter column
        if( get( _column, 'sortAndFilterConfig.filter' ) && ! isEmpty( selectedSortFilters[ _column.name ] ) ) {
            
            filterSection = [ ...filterSection, _column.name ];
        }

    } );

    // filter operation
    if( 0 !== size( filterSection ) ) {

        filteredItems = filter( cloneDeep( originalItems ), list => {

            for( const key in filterSection ) {

                const filterKey = filterSection[ key ];

                // return if all is selected
                if( SELECT_ALL_OPTION_VALUE === head( selectedSortFilters[ `${filterKey}` ] ) ) {
                    return true;
                }

                if ( list.values[ `${filterKey}` ] === undefined || -1 === indexOf( selectedSortFilters[ `${filterKey}` ], list.values[ `${filterKey}` ] ) ) {
                    return false;
                }

                return true;
            }
        } );
    }
    
    // for each selected column, filter items
    forEach( selectedColumns, _column => {

        // filter column
        // if( get( _column, 'sortAndFilterConfig.filter' ) ) {
            
        // }

        /*-----------*/

        // sort column
        if( get( _column, 'sortAndFilterConfig.sort' ) ) {

            // column type : date
            if( _column.type === DATA_TYPES.DATE ) {
                filteredItems.sort( ( itemA, itemB ) => {

                    if( ! isNil( get( _column, 'uiConfig.format', null ) ) && DATE_TIME_INFO_FORMAT === get( _column, 'uiConfig.format', null ) ) {

                        if( get( itemA, `values.${ _column.name }` ).search( 'AM' ) || get( itemA, `values.${ _column.name }` ).search( 'PM' ) ) {

                            let aIndex = get( itemA, `values.${ _column.name }` ).search( 'AM' );
                            if( -1 === aIndex ) {
                                aIndex = get( itemA, `values.${ _column.name }` ).search( 'PM' );
                            }

                            let bIndex = get( itemB, `values.${ _column.name }` ).search( 'AM' );
                            if( -1 === bIndex ) {
                                bIndex = get( itemB, `values.${ _column.name }` ).search( 'PM' );
                            }

                            const aDate = get( itemA, `values.${ _column.name }` ).substr( 0, aIndex + 2 );
                            const bDate = get( itemB, `values.${ _column.name }` ).substr( 0, bIndex + 2 );

                            const valueA = moment( aDate, get( _column, 'uiConfig.format', null ) ).toDate();
                            const valueB = moment( bDate, get( _column, 'uiConfig.format', null ) ).toDate();

                            // descending
                            if( selectedSortFilters[ _column.name ] === SORT_DIRECTIONS.DESCENDING ) {
                                return valueB - valueA;
                            }

                            // ascending
                            return valueA - valueB;
                        }
                    }

                    // values
                    const valueA = moment( get( itemA, `values.${ _column.name }` ), 'MM-DD-YYYY' ).toDate();
                    const valueB = moment( get( itemB, `values.${ _column.name }` ), 'MM-DD-YYYY' ).toDate();

                    // descending
                    if( selectedSortFilters[ _column.name ] === SORT_DIRECTIONS.DESCENDING ) {
                        return valueB - valueA;
                    }

                    // ascending
                    return valueA - valueB;
                } );
            } else {

                // column type : other
                return filteredItems.sort( ( itemA, itemB ) => {
    
                    // values
                    const valueA = get( itemA, `values.${ _column.name }` );
                    const valueB = get( itemB, `values.${ _column.name }` );
    
                    // descending
                    if( selectedSortFilters[ _column.name ] === SORT_DIRECTIONS.DESCENDING ) {
                        return valueA < valueB ? 1 : -1;
                    }
    
                    // ascending
                    return valueA < valueB ? -1 : 1;
                } );
            }
        }
    } );

    // local search
    if( ! isEmpty( searchFilter ) && 0 !== size( searchableColumns ) ) {
        
        const itemsList = [];
    
        forEach( cloneDeep( filteredItems ), item => {
            forEach( searchableColumns, column => {
                if( startsWith( item.values[ `${ column }` ], searchFilter.value ) ) {
                    itemsList.push( item );
                }
            } );
        } );

        return itemsList;
    }
    
    // return filtered items
    return filteredItems;
};
